import { AxiosResponse } from 'axios';
import api from 'api/base';
import { GetSidebarMenuItemsResponse } from 'features/sidebar/api/types';

export const getSidebarItemsAPI = async (): Promise<
  AxiosResponse<GetSidebarMenuItemsResponse>
> => {
  return api.get<GetSidebarMenuItemsResponse>('/admin/sidebar/menu-items');
};
